import { checkLicensePermission } from '../../utility/communityLicense'
import PageHeader from '../common/PageHeader/PageHeader'
import { Outlet, useLocation, matchPath, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import './MembersLayout.module.scss'
import { useEffect } from 'react'
import { setCurrentTab } from '../../actions/commonActions'
import { getActiveCommunity } from '../../utility/activeCommunity'

const paths = [
  { path: '/members/families/:familyId/enrollments', backTo: '/members/families' },
  { path: '/members/families/:familyId/contact', backTo: '/members/families' },
]

const MembersLayout = () => {
  const { t } = useTranslation()
  const { pathname, state } = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const licenseType = useSelector(state => getActiveCommunity(state.user.current_user, state.user.active_community_id)?.license_type)

  const backTo = paths.find((path) => matchPath(path, pathname))?.backTo
  const fromFamiliesPage = state?.from === 'members-families-page'

  useEffect(() => {
    dispatch(setCurrentTab('Members'))
  }, [dispatch])

  const FamilyHeaderActionButton = (
    <button
      className='btn btn-primary text-white pull-right mr-2'
      onClick={() => navigate('/students-families/invite-families')}
    >
      {t('members.membersLayout.inviteFamily')}
    </button>
  )

  return (
    <div id='membersLayout'>
      <PageHeader
        title={t('members.membersLayout.title')}
        actionComponent={checkLicensePermission(licenseType, ['standard_legacy']) ? FamilyHeaderActionButton : null}
        backButton={fromFamiliesPage}
        onClickBack={() => navigate(fromFamiliesPage ? backTo : -1)}
      />
      <Outlet />
    </div>
  )
}

export default MembersLayout
